import { render, staticRenderFns } from "./tel-team-case-manage.vue?vue&type=template&id=42d6737c&scoped=true"
import script from "./tel-team-case-manage.vue?vue&type=script&lang=ts"
export * from "./tel-team-case-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d6737c",
  null
  
)

export default component.exports